import validate from "/builds/proverky/proverky.net/frontend/node_modules/.pnpm/nuxt@3.12.3_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.2.1_db0@0.3.2_esl_eaa8de399f7c8293c61483be9e38c7a2/node_modules/nuxt/dist/pages/runtime/validate.js";
import resolver_45global from "/builds/proverky/proverky.net/frontend/middleware/resolver.global.ts";
import manifest_45route_45rule from "/builds/proverky/proverky.net/frontend/node_modules/.pnpm/nuxt@3.12.3_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.2.1_db0@0.3.2_esl_eaa8de399f7c8293c61483be9e38c7a2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  resolver_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}